import { useAuth } from "m2m-components/storage/useM2mAuth"
import { useParams } from "react-router-dom"
import { TroubleReport } from "../../templates/TroubleReport"
import { assertIsDefined } from "@/utils/assetIsDefined"
import { callRequestCreateTroubleWithUploadedPictures } from "@/hooks/useCleaningInfos"
import { genCleaningReportPagePath } from "@/routes/protected"

export const TroubleReportPage = () => {
    const { cleaningId } = useParams<"cleaningId">()
    assertIsDefined(cleaningId)
    const pathToNavigate = genCleaningReportPagePath(
        cleaningId,
        "troubles/next"
    )
    const { token } = useAuth()

    return (
        <TroubleReport
            operationId={cleaningId}
            troubleReportedPath={pathToNavigate}
            skippable={true}
            onSubmit={input =>
                callRequestCreateTroubleWithUploadedPictures(
                    token,
                    cleaningId,
                    input
                )
            }
        />
    )
}
